module.exports = __webpack_public_path__ + "img/measureImage.0180f8e1.svg";